// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"a4f2c559","223":"c02559b4","394":"b0c2d9dd","634":"9f4acc58","929":"fba468a1"}[chunkId] + ".chunk.css";
};